import { Component, Input } from '@angular/core';
import { LayoutService } from '@finder/shared/services/layout/layout.service';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { SystemErrorComponent } from '../system-error/system-error.component';
import { CommonModule } from '@angular/common';
import { SsrService } from '@finder/shared/services/ssr/ssr.service';

@Component({
    selector: 'finder-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    imports: [
        LoadingSpinnerComponent,
        SystemErrorComponent,
        CommonModule,
    ]
})
export class LayoutComponent {
    @Input() error: any;
    @Input() languageBundle: any;
    @Input() loaded = false;

    constructor(
        public layoutService: LayoutService,
        private ssrService: SsrService
    ) {
        if (this.ssrService.isSSR()) {
            this.loaded = true;
        }
    }
}
